import * as React from 'react';

import { clsx } from '@freelancelabs/utils';

import { Scroll } from '../../atoms/scroll';

/**
 * The body of a modal. It carries its own padding so that its content lines up with
 * the title above it: until it did, every consumer had to guess a value, which is how
 * a modal ends up with its heading and its text on two different left edges.
 *
 * That padding is declared on the scrolling element inside `Scroll`, not on this one.
 * See `_modal.scss`: this element does not clip, `.scroll-inner` does, and a focus ring
 * is painted outside the field's border box, so the room for it has to be on the
 * clipping side of the boundary. Moving it back up here would look like a
 * simplification and would silently shave the ring off again.
 */
const ModalContent = ({ children, className }: React.ComponentPropsWithoutRef<'div'>) => {
    return <Scroll className={clsx('modal_content', className)}>{children}</Scroll>;
};

export default ModalContent;
